export default function phasesSimulation() {
    if(document.querySelector(".page-simulation")) {
        const phases = document.querySelectorAll(".tab-header-item");
        const btnNextPhase = document.querySelectorAll(".button-next-phase");
        const btnPrevPhase = document.querySelectorAll(".button-prev-phase");
        let qtdPhaseActive = 0;
    
        btnNextPhase.forEach(btn => {
            btn.addEventListener("click", () => {
                if(qtdPhaseActive < (phases.length -1)) {
                    qtdPhaseActive++;
                }

                phases[qtdPhaseActive].classList.add("phase-active");
            });
        });
    
        btnPrevPhase.forEach(btn => {
            btn.addEventListener("click", () => {
                phases[qtdPhaseActive].classList.remove("phase-active");
    
                qtdPhaseActive--;
            });
        });
    }
}